export default {
  name: 'damage-checks',
}
